import { TableColumn } from "./dataInterface";

export const tossUpFormTableColumn: TableColumn = {
  title: "トスアップフォーム一覧",
  detail: false,
  detailTitle: "トスアップフォーム詳細",
  detailColumn: "詳細",
  detailKey: ["id", "category_id"],
  addTitle: "トスアップフォーム登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "削除",
      width: "40px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "entry_form_edit_flg",
      name: "質問追加・削除",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "140px",
      sort: false,
      tableValue: "edit_check",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "category_name",
      name: "カテゴリ",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "category",
      detail: true,
      edit: false,
      editType: "list",
      editId: "id",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "category_id",
      name: "カテゴリ",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "category",
      addMessage: "",
    },
    {
      key: "toss_up_company_id",
      name: "トスアップパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "250px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editType: null,
      editId: "id",
      add: true,
      addType: "company",
      addMessage: "",
    },
    {
      key: "toss_up_company_name",
      name: "トスアップパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "250px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editType: null,
      editId: "id",
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "チャットアプリ連携一覧",
      subTableColumnLength: "chat_app_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "170px",
      subTableDetail: true,
      subTableDetailTitle: "チャットアプリ連携詳細",
      subTableAdd: true,
      subTableAddTitle: "チャットアプリ連携追加",
      subTableAddTitleWidth: "180px",
      subTableEdit: true,
      subTableEditTitle: "チャットアプリ連携編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "toss_up_form_id",
          name: "トスアップフォームID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sns_type",
          name: "チャットアプリ連携タイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "sns_id",
          name: "連携ID",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sns_haeder",
          name: "チャットアプリ連携時ヘッダー",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※末尾に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
        {
          key: "sns_footer",
          name: "チャットアプリ連携時フッター",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※先頭に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
        {
          key: "sns_toss_up_account_info",
          name: "トスアップ担当者情報の送付",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "チャット連携-依存質問-選択肢一覧",
          subTableColumnLength: "chat_app_depend_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存質問-選択肢詳細",
          subTableAdd: true,
          subTableAddTitle: "依存質問-選択肢追加",
          subTableAddTitleWidth: "130px",
          subTableEdit: false,
          subTableEditTitle: "依存質問-選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
          tableFunction: [
            {
              name: "削除",
              auth: ["マスターアカウント", "スタッフアカウント"],
            },
          ],
          subDataColumn: [
            {
              key: "depend_option_name",
              name: "依存質問名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "depend_option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      mainTableDetail: true,
      mainTableDetailColumn: "質問一覧 詳細 / 編集",
      subTableColumnName: "質問一覧",
      subTableColumnLength: "option_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "170px",
      subTableDetail: false,
      subTableDetailTitle: "質問一覧詳細",
      subTableAdd: false,
      subTableAddTitle: "",
      subTableAddTitleWidth: "120px",
      subTableEdit: false,
      subTableEditTitle: "質問一覧編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "product_id",
          add: false,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: false,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "option_name",
          name: "質問名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sns_send",
          name: "チャットアプリ連携",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "required_optional",
          name: "必須フラグ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_type",
          name: "質問区分",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_default_value",
          name: "デフォルト値",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "change_value_conf",
          name: "入力値の編集",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_comment",
          name: "説明",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_flg",
          name: "フラグ設定",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_select",
          name: "選択肢",
          table: false,
          tableValue: null,
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "選択肢一覧",
          subTableColumnLength: "option_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "選択肢詳細",
          subTableAdd: false,
          subTableAddTitle: "選択肢追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "依存商材一覧",
          subTableColumnLength: "option_depend_product_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "依存プラン詳細",
          subTableAdd: false,
          subTableAddTitle: "依存プラン追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "依存プラン編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "high_rank_company_name",
              name: "依存上位店名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "product_name",
              name: "依存商材名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          mainTableDetail: false,
          mainTableDetailColumn: "",
          subTableColumnName: "依存質問-選択肢一覧",
          subTableColumnLength: "option_depend_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存質問-選択肢詳細",
          subTableAdd: false,
          subTableAddTitle: "依存質問-選択肢追加",
          subTableAddTitleWidth: "160px",
          subTableEdit: false,
          subTableEditTitle: "依存質問-選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "depend_option_name",
              name: "依存質問名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "depend_option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
  ],
};
